import { render, staticRenderFns } from "./RegionLabel.vue?vue&type=template&id=f13bfa06&scoped=true&"
import script from "./RegionLabel.vue?vue&type=script&lang=js&"
export * from "./RegionLabel.vue?vue&type=script&lang=js&"
import style0 from "./RegionLabel.vue?vue&type=style&index=0&id=f13bfa06&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13bfa06",
  null
  
)

export default component.exports